import * as React from "react";

import './Footer.scss';

// tslint:disable-next-line:no-empty-interface
export interface IFooterProps {
}

// tslint:disable-next-line:no-empty-interface
export interface IFooterState {
}

export class Footer extends React.Component<IFooterProps, IFooterState> {
  constructor(props: IFooterProps) {
    super(props);
  }

  public render() {
    return <footer className="footer-bar">
      <div className="footer-content footer-font">
        Todos os direitos reservados &copy; BOOKINFO |
        <span className="footer-font">contato@bookinfo.com.br</span>
        ou
        <span className="footer-font">suporte@bookinfo.com.br</span>
      </div>
    </footer>;
  }
}



// WEBPACK FOOTER //
// ./src/component/shared/layout/footer/Footer.tsx